import { styled } from '../design-tokens';
import { Grid } from '../grid';

export const VariationSectionContainer = styled(Grid, {
  gap: '2px',
});
